import { SearchActionTypes } from '../../../enums/ActionEnums';
export const initialState = {
    searchValue: '',
    selectedRow: -1,
    resultsLimit: 3,
    searchKeywords: [],
    searchBrands: [],
    searchCategories: [],
    searchBrandAsCategories: [],
    searchProducts: [],
    searchContent: [],
};
export const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SearchActionTypes.FIND:
            const { searchContent, searchSuggestions } = action.payload;
            return Object.assign(Object.assign({}, state), { searchKeywords: searchSuggestions.keywords || [], searchBrands: searchSuggestions.brands || [], searchCategories: searchSuggestions.categories || [], searchBrandAsCategories: searchSuggestions.brandAsCategories || [], searchProducts: searchSuggestions.products || [], searchContent: searchContent || [] });
        default:
            return state;
    }
};
